import { defineStore } from 'pinia'
import { ref } from 'vue'

const DEFAULT_DURATIONS = {
  success: 5000,
  info: 10000,
  warning: 10000,
  error: 10000,
}

let _nextId = 0
const generateId = () => ++_nextId

export const useSnackbarStore = defineStore('snackbar', () => {
  const items = ref([])

  function push(options) {
    const duration = 'duration' in options
      ? options.duration
      : DEFAULT_DURATIONS[options.type]

    const item = {
      id: generateId(),
      type: options.type ?? 'info',
      message: options.message,
      duration,
      showProgress: 'showProgress' in options ? options.showProgress : options.type !== 'error',
      showClose: options.showClose !== false,
      action: options.action ?? null,
    }

    items.value.unshift(item)
    return item.id
  }

  function remove(id) {
    const index = items.value.findIndex(item => item.id === id)
    if (index !== -1) items.value.splice(index, 1)
  }

  function clear() {
    items.value = []
  }

  return { items, push, remove, clear }
})
